const forms = () => {
  document.querySelectorAll('.form.js-validate').forEach(form => {
    let recaptcha;
    if (form.querySelector('.g-recaptcha')) {
      recaptcha = document
        .querySelector("meta[name='recaptcha_site_key']")
        .getAttribute('content');
    } else {
      recaptcha = false;
    }

    let alertMessages = JSON.parse(form.dataset.alerts);
    let submitBtn = form.querySelector('button[type="submit"]');

    if (typeof submitBtn != 'undefined' && submitBtn != null) {
      submitBtn.disabled = false;
    }

    new Validate(form, {
      recaptchaSiteKey: recaptcha,
      fieldFeedbackSelector: '.js-field-feedback span',
      ajax: true,
      ajaxSuccessCallback: () => {
        enableSubmitBtn();
        sendToGoogleTagManager();
      },
      ajaxErrorCallback: () => {
        enableSubmitBtn();
      },
      localisation: {
        validity: {
          valueMissing: 'This is a required field',
          typeMismatchEmail: 'Please enter a valid email address',
          typeMismatchUrl: 'Please enter a valid website address',
          tooShort: 'Must be a minimum of $0 characters',
          tooLong: 'Must be a maximum of $0 characters',
          rangeUnderflow: 'Must be after $0',
          rangeOverflow: 'Must not before $0',
          patternMismatch: 'Please match the format requested',
          default: 'There was a problem with the inputted data',
          multicheckMissing: 'Please select an option',
          multicheckMin: 'Please select a minimum of $0 options',
          multicheckMax: 'Please select a maximum of $0 options',
        },
        alerts: {
          recaptchaExpired: 'reCAPTCHA has expired, please try again',
          recaptchaProblem:
            'There is a problem with reCAPTCHA, please try again',
          submissionProblem: alertMessages.invalid,
          submissionSuccess: alertMessages.valid,
        },
      },
    });

    form.addEventListener('submit', function (e) {
      disableSubmitBtn();
    });

    // Enable Submit Button & Hide ajax loader
    function enableSubmitBtn() {
      if (typeof submitBtn != 'undefined' && submitBtn != null) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is_ajax-loading');
      }
    }

    function sendToGoogleTagManager() {

      window.dataLayer = window.dataLayer || []

      switch(form.id) {
        case 'simple_test':
          window.dataLayer.push({
            'event': 'simple test form'
          });
          break;
        case 'request_training':
          window.dataLayer.push({
            'event': 'request sales office training form submission'
          });
          break;
        case 'order_marketing':
          window.dataLayer.push({
            'event': 'order marketing material form submission'
          });
          break;
        case 'request_mifi':
          window.dataLayer.push({
            'event': 'request mifi units form submission'
          });
          break;
        case 'upload_schedules':
          window.dataLayer.push({
            'event': 'upload address schedules form submission'
          });
          break;
        default:
        return;
      }
    }

    // Disable Submit Button & Show ajax loader
    function disableSubmitBtn() {
      if (typeof submitBtn != 'undefined' && submitBtn != null) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is_ajax-loading');
      }
    }
  });

  // In-field Labels
  document.querySelectorAll('.js-infield').forEach(field => {
    field.addEventListener('keyup', event => {
      field.setAttribute('value', field.value);
    });
  });
};

export default forms;
